import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';

const statistiquesInfrastructuresData = [ 
    {
    ministere: 'Ministère des Infrastructures, de l’Equipement et des Logements Sociaux',
    annuaires: 'ANNUAIRE DES STATISTIQUES ÉDITION 2023',
    description: 'Les statistiques sur les infrastructures et le logement social, fournissant un aperçu du développement des projets et de l’impact sur les communautés locales.',
    date: "2020-12-31",
    link: "/documents/Sectorials/annuaire_statistique _MIELS_2024.pdf",
  },
  {
    ministere: 'Ministère des Infrastructures, de l’Equipement et des Logements Sociaux',
    annuaires: 'ANNUAIRE DES STATISTIQUES ÉDITION 2022',
    description: 'Les statistiques sur les infrastructures et le logement social, fournissant un aperçu du développement des projets et de l’impact sur les communautés locales.',
    date: "2020-12-31",
    link: "/documents/Sectorials/Annuaire-statistique-2022_MIELS.pdf",
  },
  {
    ministere: 'Ministère des Infrastructures, de l’Equipement et des Logements Sociaux',
    annuaires: 'ANNUAIRE DES STATISTIQUES ÉDITION 2021',
    description: 'Les statistiques sur les infrastructures et le logement social, fournissant un aperçu du développement des projets et de l’impact sur les communautés locales.',
    date: "2020-12-31",
    link: "/documents/Sectorials/annuaire-statistique-MIELS_2021.pdf",
  },
  {
    ministere: 'Ministère des Infrastructures, de l’Equipement et des Logements Sociaux',
    annuaires: 'ANNUAIRE DES STATISTIQUES ÉDITION 2020',
    description: 'Les statistiques sur les infrastructures et le logement social, fournissant un aperçu du développement des projets et de l’impact sur les communautés locales.',
    date: "2020-12-31",
    link: "/documents/Sectorials/Annuaire-statistique-2020.pdf",
  },
  {
    ministere: 'Ministère des Infrastructures, de l’Equipement et des Logements Sociaux',
    annuaires: 'ANNUAIRE DES STATISTIQUES ÉDITION 2019',
    description: 'Une analyse des statistiques mentionnant les initiatives en matière de logement social et d’équipement public pour mieux répondre aux besoins des citoyens.',
    date: "2019-12-31",
    link: "/documents/Sectorials/Annuaire-statistique-MIELS-2020.pdf",
  },
  {
    ministere: 'Ministère des Transports, des Travaux Publics, de l’Equipement et de l’Aménagement du Territoire',
    annuaires: 'ANNUAIRE STATISTIQUE EDITION 2018',
    description: 'Une évaluation des statistiques sur les projets de travaux publics et leur impact sur le développement des infrastructures de transport, essentielle pour la mobilité et la prospérité économique.',
    date: "2018-12-31",
    link: "/documents/Sectorials/Annuaire-statistique-MTTPEAT-2018.pdf",
  },
];

function MinistereInfrastructures() {
  const [visibleCount, setVisibleCount] = useState(2); 
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredStatistiques, setFilteredStatistiques] = useState(statistiquesInfrastructuresData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => Math.min(prevCount + 2, filteredStatistiques.length)); 
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    
    if (year === 'Tous') {
      setFilteredStatistiques(statistiquesInfrastructuresData);
    } else {
      const filtered = statistiquesInfrastructuresData.filter((statistique) => {
        const statistiqueYear = new Date(statistique.date).getFullYear();
        return statistiqueYear === parseInt(year);
      });

      // Trier par date de publication la plus récente en premier
      filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
      setFilteredStatistiques(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
      h4: {
        fontWeight: '600',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
           Ministère des Infrastructures,des Logements Sociaux, des Transports et de l'Equipement
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Le Ministère des Infrastructures, de l’Equipement et des Logements Sociaux est responsable du développement et de la maintenance des infrastructures essentielles qui soutiennent les communautés. Cette page fournit un aperçu des statistiques liées aux infrastructures et au logement social.
          </Typography>
          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Filtrer par année de réalisation</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Filtrer par année de réalisation"
            >
              <MenuItem value="Tous">Tous les annuaires</MenuItem>
              {[...new Set(statistiquesInfrastructuresData.map((statistique) => new Date(statistique.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          <Grid container spacing={1} style={{ marginTop: '5px' }}>
            {filteredStatistiques.slice(0, visibleCount).map((statistique, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={statistique.link}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 71, height: 100, m: 2 }}
                        image={"assets/annuaires/miniinfranstr.png"} 
                        alt={statistique.annuaires}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a
                          href={statistique.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                          {<DownloadIcon />}{statistique.annuaires}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {statistique.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(statistique.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredStatistiques.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Statistiques
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default MinistereInfrastructures;